import { Button } from "@shared/ui.primitives";
import React, { useEffect, useRef } from "react";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<
    ProductCardDataType,
    "buttonText" | "isPrimaryButtonDisabled" | "prices" | "inStock"
  >;
  onClick?: () => void;
  variant?: "primary" | "secondary";
};

export const VerticalProductCardButton: React.FC<Props> = ({
  product,
  onClick,
  variant = "primary"
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  // Determine button text based on stock and pricing
  const getButtonText = () => {
    // Fall back to buttonText if prices are not available
    if (!product.prices?.activeType) {
      return product.buttonText;
    }

    // Use active pricing label for in-stock items
    const activePricing = product.prices[product.prices.activeType];
    return (
      activePricing?.promo?.label ||
      activePricing?.regular?.label ||
      product.buttonText
    );
  };
  const buttonText = getButtonText();

  useEffect(() => {
    if (buttonRef && buttonRef.current) {
      buttonRef.current.dataset.testRenderState = "complete";
    }
  }, [buttonText]);

  return (
    <Button
      ref={buttonRef}
      variant={variant}
      size="medium"
      onClick={(event) => {
        event?.preventDefault();
        event?.stopPropagation();
        onClick?.();
      }}
      disabled={product.isPrimaryButtonDisabled}
      text={buttonText}
    />
  );
};
